import { schema } from 'normalizr';

import { processGroup } from '../strategies/group';

import { groupLinksSchema } from './groupLink';

export const groupSchema: schema.Entity = new schema.Entity(
  'groups',
  {
    groupLinkId: groupLinksSchema,
  },
  { processStrategy: processGroup }
);
